import {useSessionStorage} from "@vueuse/core";
import {useCookie} from "nuxt/app";
import {PaymentMethodEnvironment} from "../graphql";

type DataLegacy = {
	fingerprint?: string;
	actionData?: string;
	environment?: PaymentMethodEnvironment;
};

type Data = {
	// The identifier of the order payment, set after initializing the payment resource on our end
	fingerprint: string;
	// Payment initialization data from Avarda, most notably the JWT token we pass into avarda's widget so that it knows which payment we're processing (see https://docs.avarda.com/checkout-3/getting-started)
	// JSON-stringified object (rather than plain object), for legacy reasons
	actionData: string;
	// production / testing
	environment: PaymentMethodEnvironment;
};

export function useOrderPaymentStorage() {
	const cookieData = useCookie<Data | undefined>("order_payment_data");

	const storageData = useSessionStorage<DataLegacy>("order-payment-data", {});

	return {
		get(): Data | undefined {
			if (cookieData.value) {
				return cookieData.value;
			}
			// Legacy
			const {fingerprint, actionData, environment} = storageData.value;
			if (fingerprint && actionData && environment) {
				return {
					fingerprint,
					actionData,
					environment,
				};
			}
			storageData.value = null;

			return undefined;
		},
		set(value: Data) {
			cookieData.value = value;
			// Legacy: Clear this when setting cookie data so that it'll never get used again
			storageData.value = null;
		},
		clear() {
			cookieData.value = undefined;
			// Legacy
			storageData.value = null;
		},
	};
}
